import React, { CSSProperties } from 'react';

const styles: { [key: string]: CSSProperties } = {
  container: {
    fontFamily: 'Arial, sans-serif',
    color: '#333',
    padding: '2rem',
    maxWidth: '800px',
    margin: '2rem auto',
    backgroundColor: '#e3f2fd', // A very light blue
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    border: '2px solid #007bff', // A prominent blue border
  },
  header: {
    textAlign: 'center',
    marginBottom: '2rem',
  },
  h1: {
    color: '#007bff',
    fontSize: '2.8rem',
    marginBottom: '0.5rem',
  },
  p: {
    lineHeight: '1.6',
    color: '#555',
  },
  cardSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    borderLeft: '5px solid #4CAF50', // A prominent green accent
  },
  cardHeader: {
    marginBottom: '1.5rem',
  },
  title: {
    color: '#0056b3',
    fontSize: '2rem',
    marginBottom: '0.5rem',
  },
  tagline: {
    color: '#4CAF50',
    fontStyle: 'italic',
    fontSize: '1.1rem',
  },
  details: {
    lineHeight: '1.8',
  },
  list: {
    listStyleType: 'disc',
    paddingLeft: '1.5rem',
    marginTop: '1rem',
  },
  oldPrice: {
    textDecoration: 'line-through',
    color: '#999',
  },
  newPrice: {
    fontWeight: 'bold',
    color: '#4CAF50',
    fontSize: '1.2rem',
  },
  cta: {
    fontWeight: 'bold',
    color: '#0056b3',
    marginTop: '1.5rem',
    textAlign: 'center',
  },
  footer: {
    textAlign: 'center',
    marginTop: '3rem',
    paddingTop: '1.5rem',
    borderTop: '1px solid #cce5ff',
    color: '#666',
  },
};

const Promotions: React.FC = () => {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.h1}>Current Promotions</h1>
        <p style={styles.p}>Take advantage of our limited-time offers to grow your business on GremaGlobal.</p>
      </header>
      <div style={styles.cardSection}>
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h2 style={styles.title}>50% Discount on Advertising</h2>
            <p style={styles.tagline}>Boost your reach for half the price!</p>
          </div>
          <div style={styles.details}>
            <p style={styles.p}>
              We are currently offering a <strong>50% discount</strong> on our monthly advertising rates. This is the perfect opportunity to get your business noticed on our platform at an unbeatable price.
            </p>
            <ul style={styles.list}>
              <li>
                <strong>Standard Adverts:</strong> <span style={styles.oldPrice}>UGX. 100,000</span> <span style={styles.newPrice}>UGX. 50,000</span> (approx. $15) per month
              </li>
              <li>
                <strong>Premium Adverts:</strong> <span style={styles.oldPrice}>UGX. 400,000</span> <span style={styles.newPrice}>UGX. 200,000</span> (approx. $60) per month
              </li>
            </ul>
          </div>
        </div>
        {/* <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h2 style={styles.title}>Extended Subscription Offer</h2>
            <p style={styles.tagline}>Subscribe now and get September for free!</p>
          </div>
          <div style={styles.details}>
            <p style={styles.p}>
              If you <strong>subscribe before 30th November 2025</strong>, you will receive the remaining days of September completely free. Your paid subscription will officially begin on <strong>1st December 2025</strong>.
            </p>
            <p style={{ ...styles.p, ...styles.cta }}>
              Don't miss out on this incredible deal. Secure your advertising space today!
            </p>
          </div>
        </div> */}
      </div>
      
    </div>
  );
};

export default Promotions;